import React from 'react';
import {FC, Fragment} from 'react';
import messages from '../messages';
import useSaveProductAsForm from './use-action-variant-to-old-collection';
import Button from 'components/button';
import {Trans, useTranslation} from 'react-i18next';
import {ModalBody, ModalFooter, ModalHeader} from 'reactstrap';
import AsyncItemPicker from 'components/async-item-picker';
import { Product } from 'types/product';

const VariantTOCActionConfirm: FC<Props> = props => {
  const {onDismiss} = props;

  const {t} = useTranslation();

  const {submit, isLoading, params, validationErrors, setParams} = useSaveProductAsForm(onDismiss);

  return (
    <Fragment>
      <ModalHeader className="bg-primary" toggle={onDismiss}>
        <span className="text-light">
          <Trans i18nKey={messages.title()} />
        </span>
      </ModalHeader>
    
      <ModalBody className="">
        <AsyncItemPicker
          endPoint="data/products"
          className="mb-1"
          label={t(...messages.inputLabel())}
          optionLabel=""
          errors={validationErrors?.productId}
          value={params.product}
          onChange={(product: Product) =>
            setParams({...params, product})
          }
        />

      </ModalBody>
      <ModalFooter>
        <Button color="important" onClick={submit} isLoading={isLoading}>
          {t(...messages.yesImSure())}
        </Button>
        <Button color="secondary" onClick={onDismiss}>
          {t(...messages.cancel())}
        </Button>
      </ModalFooter>
    </Fragment>
  );
};

interface Props {
  message?: string;
  onDismiss: () => void;
}

export default VariantTOCActionConfirm;
